document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-menu-toggle]');
  const drawer = document.querySelector('[data-mobile-drawer]');
  if (toggle && drawer) {
    toggle.addEventListener('click', () => {
      const isOpen = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!isOpen));
      drawer.hidden = isOpen;
      document.body.classList.toggle('menu-open', !isOpen);
    });
  }
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-product-section]').forEach((section) => {
    const jsonNode = section.querySelector('[data-product-json]');
    const form = section.querySelector('.product-form');
    if (!jsonNode || !form) return;

    let product;
    try { product = JSON.parse(jsonNode.textContent); } catch (error) { return; }

    const variantInput = form.querySelector('[data-variant-id]');
    const addButton = form.querySelector('[data-add-to-cart]');
    const priceNode = section.querySelector('[data-product-price]');
    const optionSelects = Array.from(form.querySelectorAll('[data-option-index]'));
    const mediaItems = Array.from(section.querySelectorAll('[data-media-id]'));

    const formatMoney = (cents) => {
      const currency = document.documentElement.getAttribute('data-currency') || 'INR';
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-IN', {
          style: 'currency', currency
        }).format(cents / 100);
      } catch (e) {
        return (cents / 100).toFixed(2);
      }
    };

    const updateGallery = (variant) => {
      if (!mediaItems.length) return;
      const hasVariantMedia = mediaItems.some((item) => {
        const ids = (item.dataset.variantIds || '').split(',').filter(Boolean);
        return ids.includes(String(variant.id));
      });

      // Keep shared/general images visible. When this variant has assigned media,
      // hide media assigned exclusively to other variants.
      mediaItems.forEach((item) => {
        const ids = (item.dataset.variantIds || '').split(',').filter(Boolean);
        const isShared = ids.length === 0;
        const belongsToVariant = ids.includes(String(variant.id));
        item.hidden = hasVariantMedia ? !(isShared || belongsToVariant) : false;
      });

      const selectedMedia = variant.featured_media && variant.featured_media.id;
      if (selectedMedia) {
        const target = section.querySelector('[data-media-id="' + selectedMedia + '"]');
        if (target && !target.hidden) target.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    };

    const updateVariant = () => {
      const values = optionSelects.map((select) => select.value);
      const variant = product.variants.find((candidate) =>
        candidate.options.every((value, index) => value === values[index])
      );

      if (!variant) {
        if (variantInput) variantInput.value = '';
        if (addButton) {
          addButton.disabled = true;
          addButton.textContent = 'UNAVAILABLE';
        }
        return;
      }

      if (variantInput) variantInput.value = variant.id;
      if (addButton) {
        addButton.disabled = !variant.available;
        addButton.textContent = variant.available
          ? 'ADD TO BAG — ' + formatMoney(variant.price)
          : 'SOLD OUT';
      }
      if (priceNode) priceNode.textContent = formatMoney(variant.price);
      if (window.history && window.history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
      updateGallery(variant);
    };

    optionSelects.forEach((select) => select.addEventListener('change', updateVariant));

    // Respect a variant selected from a product-card link (?variant=ID).
    const queryVariant = new URLSearchParams(window.location.search).get('variant');
    const initialVariant = product.variants.find((variant) => String(variant.id) === queryVariant)
      || product.variants.find((variant) => String(variant.id) === String(variantInput.value))
      || product.variants[0];

    if (initialVariant) {
      optionSelects.forEach((select, index) => {
        if (initialVariant.options[index] !== undefined) select.value = initialVariant.options[index];
      });
      updateVariant();
    }
  });
});
